import {CohortReport} from "./reducer";

export const TransformReportResponse = (response: CohortResponse): CohortReport => {
    let rows = response.rows;

    rows.sort((a,b) => {
        return a.eventsD180 > b.eventsD180 ? -1 : 1;
    })

    return {
        from: response.from,
        until: response.until,
        rows: response.rows,
    }
}

export interface CohortResponseRow {
    "campaignId": number,
    "campaignName": string,
    "eventName": string,
    "installs": number,
    "spend": number,
    "eventsD0": number,
    "eventsD1": number,
    "eventsD3": number,
    "eventsD7": number,
    "eventsD14": number,
    "eventsD30": number
    "eventsD60": number
    "eventsD180": number
    "revenueD0": number,
    "revenueD1": number,
    "revenueD3": number,
    "revenueD7": number,
    "revenueD14": number,
    "revenueD30": number
    "revenueD60": number
    "revenueD180": number
}

export interface CohortResponse {
    from: Date,
    until: Date,
    rows: CohortResponseRow[];
}
